export const getSingleWidgetScript = (key, data) => `<!-- Pluspoint script -->
    <script>"loading"!==document.readyState?init():document.addEventListener("DOMContentLoaded",init);function init(){var t=document.createElement("script");t.id="pl-single-widget",t.dataset.key="${key}",t.dataset.companies="[${data.locations}]",t.dataset.brands='${data.brands}',t.dataset.channels="[${data.integrations}]",t.dataset.onlyfeatured="${data.onlyFeatured}",t.dataset.count="${data.count}",t.dataset.sorting="${data.sorting}",${getPopupPositionDataset('t', data).join(',')},t.src="${window.location.origin}/widget/pl.widget.single.min.js",document.getElementsByTagName("body")[0].appendChild(t)}</script>
<!-- End of Pluspoint script -->`;

export const getGridWidgetScript = (key, data) => `<!-- Pluspoint tag -->
    <div id="pl-grid-widget-container"></div>
<!-- End of Pluspoint tag -->
<!-- Pluspoint script -->
    <script>"loading"!==document.readyState?init():document.addEventListener("DOMContentLoaded",init);function init(){var t=document.createElement("script");t.id="pl-grid-widget",t.dataset.key="${key}",t.dataset.companies="[${data.locations}]",t.dataset.brands='${data.brands}',t.dataset.channels="[${data.integrations}]",t.dataset.onlyfeatured="${data.onlyFeatured}",t.dataset.count="${data.count}",t.dataset.sorting="${data.sorting}",t.dataset.background="${data.backgroundColor}",t.src="${window.location.origin}/widget/pl.widget.grid.min.js",document.getElementsByTagName("body")[0].appendChild(t)}</script>
<!-- End of Pluspoint script -->
`;

export const WIDGET_OFFSET_MIN = -20;
export const WIDGET_OFFSET_MAX = 200;

export const WIDGET_ALIGNMENTS = ['left', 'right'];
export const DEFAULT_WIDGET_ALIGNMENT = 'right';
export const DEFAULT_POPUP_WIDGET_ALIGNMENT = 'left';

export const POPUP_DELAY_STORAGE_KEY = 'pl-widget-single-delay';

export const normalizeWidgetAlignment = (value, fallback = DEFAULT_WIDGET_ALIGNMENT) =>
    WIDGET_ALIGNMENTS.includes(value) ? value : fallback;

const isBlankOffset = value => value === '' || value === null || value === undefined;

export const parseWidgetOffset = value => {
    if (isBlankOffset(value)) return null;
    const parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed < WIDGET_OFFSET_MIN || parsed > WIDGET_OFFSET_MAX) return null;
    return parsed;
};

export const isWidgetOffsetValid = value => isBlankOffset(value) || parseWidgetOffset(value) !== null;

export const formatWidgetOffset = value => (isBlankOffset(value) ? '' : String(value));

export const getPopupPositionDataset = (element, { alignment, offsetX, offsetY }) =>
    Object.entries({
        align: normalizeWidgetAlignment(alignment, DEFAULT_POPUP_WIDGET_ALIGNMENT),
        offsetX: parseWidgetOffset(offsetX),
        offsetY: parseWidgetOffset(offsetY),
    })
        .filter(([, value]) => value !== null)
        .map(([name, value]) => `${element}.dataset.${name}="${value}"`);

export const CHAT_WIDGET_SCRIPT_ID = 'pl-chat-widget';

export const getChatWidgetScript = channelId => `<!-- Pluspoint script -->
    <script>window.pluspoint=window.pluspoint||function(){(window.pluspoint.q=window.pluspoint.q||[]).push(arguments)};"loading"!==document.readyState?init():document.addEventListener("DOMContentLoaded",init);function init(){var t=document.createElement("script");t.id="${CHAT_WIDGET_SCRIPT_ID}",t.dataset.channelid="${channelId}",t.src="${window.location.origin}/widget/pl.widget.chat.min.js",document.getElementsByTagName("body")[0].appendChild(t)}</script>
<!-- End of Pluspoint script -->
`;
